import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import qs from "qs";
import styled from "styled-components";
import Header from "../components/Header/Header";

import Alert from "../components/Alert/Alert";
import CodeInput from "../components/CodeInput/CodeInput";
import Menu from "../components/Menu";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  position: relative;
  flex-grow: 2;
`;

const Inner = styled.div`
  max-width: 960px;
  margin: 100px auto;
`;

const PoliticianPage = ({ code, match }) =>
  code ? (
    <Redirect to={`/indienen`} />
  ) : (
    <PageWrapper>
      <Header />
      <Content>
        <Menu />
        <Inner>
          <h1>Overtuig de jongeren</h1>
          {typeof window !== "undefined" &&
          window.location.search &&
          qs.parse(window.location.search.substr(1)).wrongcode ? (
            <Alert>Je gaf een foutieve code in</Alert>
          ) : null}
          <p>
            Om jongeren wegwijs te maken in het programma van uw partij, maakte
            MNM een grote kieskaart. Op deze interactieve kaart van uw gemeente
            kan u tot 5 programmapunten voor jongeren invullen. Een unieke kans
            om met uw partij een jong publiek te bereiken!
          </p>
          <p>
            Plak hieronder uw code en ga aan de slag met de kaart van uw
            gemeente.
          </p>
          <CodeInput
            code={
              match && match.params && match.params.code
                ? match.params.code
                : null
            }
          />
          <p>
            Geen code ontvangen?{" "}
            <a href="mailto:info@kieskaart.be">Neem contact met ons op</a>.
          </p>
        </Inner>
      </Content>
    </PageWrapper>
  );

const mapStateToProps = state => {
  return {
    code: state.code
  };
};

export default connect(mapStateToProps)(PoliticianPage);



// WEBPACK FOOTER //
// ./src/pages/Politician.js